<template>
  <div>
    <validation-observer
      ref="formIndividual"
      v-if="individualCheck"
      @change="submitForm"
      #default="{ invalid }"
    >
      <b-form @submit.prevent="addLeadsIndividual">
        <b-row>
          <!-- username -->
          <b-col :cols="isEdit ? 10 : 12">
            <validation-provider
              rules="required"
              #default="{ errors }"
              name="Customer Source"
              vid="Customer Source"
            >
           
              <b-form-group label="Customer Source" label-for="h-First">

                <!-- {{ custInfo }} -->
                <b-form-select
                  v-model="profiledetails.source.leadClientDetailId"
                  :options="sourceOptions"
                />
                <small v-if="errors.length" class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="2" v-if="isEdit" class="d-flex align-items-center">
            <b-button variant="primary" class="w-100" @click="showModal('SOURCE')">
              Add Source
            </b-button>
          </b-col>
          <!-- username -->

          <b-col cols="12">
            <validation-provider
              rules="required"
              #default="{ errors }"
              name="Sales Person"
              vid="Sales Person"
            >
              <b-form-group label="Sales Person" label-for="h-First">
                <b-form-select
                  v-model="custInfo.salesPersonId"
                  :options="optionsSalesPerson"
                  :disabled="!isEdit"
                />
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="12">
            <validation-provider #default="{ errors }" name="Title" vid="Title">
              <b-form-group label="Title" label-for="h-First">
                <b-form-select
                  v-model="custInfo.title"
                  :options="options"
                  :disabled="!isEdit"
                />
                <small v-if="errors.length" class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="12">
            <b-form-group label="First Name" label-for="h-company">
              <validation-provider
                rules="required"
                #default="{ errors }"
                name="First Name"
                vid="First Name"
              >
                <b-form-input
                  id="h-full"
                  placeholder="First Name"
                  v-model="custInfo.otherName"
                  :disabled="!isEdit"
                />
                <small v-if="errors.length" class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group label="Last Name" label-for="h-company">
              <validation-provider
                rules="required"
                #default="{ errors }"
                name="Last Name"
                vid="Last Name"
              >
                <b-form-input
                  id="h-full"
                  placeholder="Last Name"
                  v-model="custInfo.surname"
                  :disabled="!isEdit"
                />
                <small v-if="errors.length" class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <!-- email -->
          <b-col cols="12">
            <validation-provider
              rules="email"
              v-slot="{ errors }"
              name="Email"
              vid="Email"
            >
              <b-form-group label="Email" label-for="d-email">
                <b-form-input
                  id="d-email"
                  type="email"
                  placeholder="Enter your email (e.g., example@domain.com)"
                  v-model="custInfo.email"
                  :disabled="!isEdit"
                />
                <small v-if="errors.length" class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
          <!-- DOB  -->
          <b-col cols="12">
            <b-form-group label="Date of Birth" label-for="dob">
              <flat-pickr
                v-model="custInfo.dob"
                :disabled="!isEdit"
                class="form-control"
                :config="config"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group label="Address" label-for="h-Address">
              <b-form-input
                id="h-Address"
                placeholder="Address"
                v-model="custInfo.addressLine1"
              />
            </b-form-group>
          </b-col>

          <b-col cols="12">
            <b-form-group label="Street Name" label-for="h-Street">
              <b-form-input
                id="h-Street"
                placeholder="Street Name"
                v-model="custInfo.addressLine2"
              />
            </b-form-group>
          </b-col>

          <b-col cols="10">
            <b-form-group label="City" label-for="h-City">
              <b-form-select
                v-model="profiledetails.city.leadClientDetailId"
                :options="cityOptions"
              />
            </b-form-group>
          </b-col>
          <b-col v-if="isEdit" cols="2" class="d-flex align-items-center">
            <b-button variant="primary" class="w-100" @click="showModal('CITY')">
              Add City
            </b-button>
          </b-col>
          <b-col cols="12">
            <b-form-group label="Tel" label-for="h-tel">
              <b-form-input
                id="h-tel"
                placeholder="Tel"
                type="number"
                onkeydown="javascript: return ['Backspace','Delete','ArrowLeft','ArrowRight'].includes(event.code) ? true : !isNaN(Number(event.key)) && event.code!=='Space'"
                v-model="custInfo.tel"
              />
            </b-form-group>
          </b-col>

          <b-col cols="12">
            <b-form-group label="Category" label-for="h-specialInstructions">
              <b-form-input
                id="h-specialInstructions"
                placeholder="Category"
                v-model="custInfo.fieldInstruction"
              />
            </b-form-group>
          </b-col>

          <b-col :cols="isEdit ? 10 : 12">
            <b-form-group label="Job Title" label-for="h-title">
              <b-form-select
                v-model="profiledetails.jobTitle.leadClientDetailId"
                :options="jobTitleOptions"
              />
            </b-form-group>
          </b-col>
          <b-col cols="2" v-if="isEdit" class="d-flex align-items-center">
            <b-button variant="primary" class="w-100" @click="showModal('JOBTITLE')">
              Add Job Title
            </b-button>
          </b-col>
          <!-- Hobbies -->
          <b-col :cols="isEdit ? 10 : 12">
            <b-form-group label="Hobbies" label-for="h-title">
              <v-select
                multiple
                placeholder="Add Hobbies"
                label="itemTitle"
                v-model="selectedHobbies"
                :options="hobbiesOptions"
              />
            </b-form-group>
          </b-col>
          <b-col v-if="isEdit" cols="2" class="d-flex align-items-center">
            <b-button variant="primary" class="w-100" @click="showModal('HOBBIE')">
              Add Hobby
            </b-button>
          </b-col>
          <b-col :cols="isEdit ? 10 : 12">
            <b-form-group label="Products interested in" label-for="h-title">
              <v-select
                multiple
                placeholder="Add Products Interested in"
                label="itemTitle"
                v-model="custInfo.comments"
                :options="productInterestOptions"
              />
            </b-form-group>
          </b-col>
          <b-col v-if="isEdit" cols="2" class="d-flex align-items-center">
            <b-button
              variant="primary"
              class="w-100"
              @click="showModal('PRODUCTINTEREST')"
            >
              Add Product Interest
            </b-button>
          </b-col>
          <!-- segments -->
          <b-col cols="12">
            <b-form-group label="Marketing Segment" label-for="h-title">
              <v-select
                multiple
                placeholder="Add Marketing Segments"
                label="itemTitle"
                v-model="selectedSegments"
                :options="segmentOptions"
              />
            </b-form-group>
          </b-col>
          <b-col class="12">
            <CustomFieldsDetails
              :AdditionalFields="custInfo.additionalFields"
              :ModuleReference="'LeadClient'"
              @onchange="additionalFieldChanges"
            />
          </b-col>
          <b-col cols="12">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="submit"
              variant="primary"
              class="mr-1"
            >
              <b-spinner small v-if="loading" />
              Submit
            </b-button>

            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              variant="outline-secondary"
              @click="resetForm"
            >
              Reset
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
    <validation-observer ref="formCompany" v-if="!individualCheck" @change="submitForm">
      <b-form @submit.prevent="addLeadsCompany">
        <b-row>
          <b-col cols="10">
            <validation-provider
              rules="required"
              v-slot="{ errors }"
              name="Lead Source"
              vid="Lead Source"
            >
              <b-form-group label="Customer Source" label-for="h-First">
                <b-form-select
                  v-model="profiledetails.source.leadClientDetailId"
                  :options="sourceOptions"
                />
                <small v-if="errors.length" class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="2" class="d-flex align-items-center">
            <b-button variant="primary" class="w-100" @click="showModal('SOURCE')">
              Add Source
            </b-button>
          </b-col>
          <b-col cols="12">
            <validation-provider
              rules="required"
              v-slot="{ errors }"
              name="Sales Person"
              vid="Sales Person"
            >
              <b-form-group label="Sales Person" label-for="h-First">
                <b-form-select
                  v-model="custInfo.salesPersonId"
                  :options="optionsSalesPerson"
                  :disabled="!Edit"
                />
                <small v-if="errors.length" class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="12">
            <b-form-group label="Company Name" label-for="h-company">
              <validation-provider
                rules="required"
                #default="{ errors }"
                name="Company Name"
                vid="Company Name"
              >
                <b-form-input
                  id="h-full"
                  placeholder="Company Name"
                  v-model="custInfo.otherName"
                  :disabled="!Edit"
                />
                <small v-if="errors.length" class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <!-- email -->
          <b-col cols="12">
            <validation-provider
              rules="email_regex"
              v-slot="{ errors }"
              name="email"
              vid="email"
            >
              <b-form-group label="Email" label-for="d-email">
                <b-form-input
                  id="d-email"
                  type="email"
                  placeholder="Enter your email (e.g., example@domain.com)"
                  v-model="custInfo.email"
                  :disabled="!Edit"
                />
                <small v-if="errors.length" class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col cols="12">
            <b-form-group label="Address" label-for="h-Address">
              <b-form-input
                id="h-Address"
                placeholder="Address"
                v-model="custInfo.addressLine1"
              />
            </b-form-group>
          </b-col>

          <b-col cols="12">
            <b-form-group label="Street Name" label-for="h-Street">
              <b-form-input
                id="h-Street"
                placeholder="Street Name"
                v-model="custInfo.addressLine2"
              />
            </b-form-group>
          </b-col>

          <b-col cols="10">
            <b-form-group label="City" label-for="h-City">
              <b-form-select
                v-model="profiledetails.city.leadClientDetailId"
                :options="cityOptions"
              />
            </b-form-group>
          </b-col>
          <b-col cols="2" class="d-flex align-items-center">
            <b-button variant="primary" class="w-100" @click="showModal('CITY')">
              Add City
            </b-button>
          </b-col>
          <b-col cols="12">
            <b-form-group label="Company Tel" label-for="h-tel">
              <b-form-input
                id="h-tel"
                placeholder="Company Tel"
                type="number"
                onkeydown="javascript: return ['Backspace','Delete','ArrowLeft','ArrowRight'].includes(event.code) ? true : !isNaN(Number(event.key)) && event.code!=='Space'"
                v-model="custInfo.tel"
              />
            </b-form-group>
          </b-col>

          <b-col cols="12">
            <b-form-group label="Category" label-for="h-specialInstructions">
              <b-form-input
                id="h-specialInstructions"
                placeholder="Category"
                v-model="custInfo.fieldInstruction"
              />
            </b-form-group>
          </b-col>

          <b-col cols="12">
            <b-form-group label="Website" label-for="h-Website">
              <b-form-input
                id="h-Website"
                placeholder="Website"
                v-model="custInfo.website"
              />
            </b-form-group>
          </b-col>

          <b-col cols="12">
            <b-form-group label="Vat Number" label-for="h-Number">
              <b-form-input
                id="h-Number"
                placeholder="Vat Number"
                v-model="custInfo.vatNumber"
              />
            </b-form-group>
          </b-col>

          <b-col cols="12">
            <b-form-group label="Company BRN" label-for="h-Number">
              <b-form-input
                id="h-Number"
                placeholder="Company BRN"
                v-model="custInfo.brn"
              />
            </b-form-group>
          </b-col>
          <b-col cols="10">
            <b-form-group label="Products interested in" label-for="h-title">
              <v-select
                multiple
                placeholder="Add Products Interested in"
                label="itemTitle"
                v-model="custInfo.comments"
                :options="productInterestOptions"
              />
            </b-form-group>
          </b-col>
          <b-col cols="2" class="d-flex align-items-center">
            <b-button
              variant="primary"
              class="w-100"
              @click="showModal('PRODUCTINTEREST')"
            >
              Add Product Interest
            </b-button>
          </b-col>
          <!-- segments -->
          <b-col cols="12">
            <b-form-group label="Marketing Segment" label-for="h-title">
              <v-select
                multiple
                placeholder="Add Marketing Segments"
                label="itemTitle"
                v-model="selectedSegments"
                :options="segmentOptions"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <CustomFieldsDetails
              :AdditionalFields="custInfo.additionalFields"
              :ModuleReference="'LeadClient'"
              @onchange="additionalFieldChanges"
            />
          </b-col>
          <b-col cols="12">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="submit"
              variant="primary"
              class="mr-1"
            >
              Submit
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              variant="outline-secondary"
              @click="resetForm"
            >
              Reset
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
    <b-modal :id="modalId" :title="modalTitle" hide-footer>
      <b-form @submit.prevent="addItem">
        <b-form-group
          :label="`Add ${getModalTitle(modalType)}`"
          label-for="input-new-item"
        >
          <b-form-input
            id="input-new-item"
            v-model="newItem"
            required
            placeholder="Enter new item"
          ></b-form-input>
        </b-form-group>
        <b-button type="submit" variant="primary">Add</b-button>
      </b-form>

      <div class="p-1" style="max-height: 500px; overflow-y: auto">
        <b-table striped hover :items="modalOptions" responsive :fields="fields">
          <template v-slot:cell(name)="data">
            {{
              modalType === "PRODUCTINTEREST" || "HOBBIE"
                ? data.item.itemTitle
                : data.item.text
            }}
          </template>
          <template #cell(actions)="data">
            <b-button
              v-if="HasPermission(PermissionList.Sales_Delete)"
              size="sm"
              variant="danger"
              @click="deleteItem(data.item.value)"
              >Delete</b-button
            >
          </template>
        </b-table>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
  BFormText,
  BFormTextarea,
  BDropdown,
  BDropdownItem,
  BFormDatalist,
  BFormSelect,
  BModal,
  VBModal,
  BTable,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, email } from "@validations";
import { mapActions, mapGetters } from "vuex";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import { PermissionList } from "@/libs/defaultList";
import { HasPermission } from "@/@core/utils/validations/permissionCheck";
import CustomFieldsDetails from "@/views/component/CustomFieldsDetails.vue";
import { extend } from "vee-validate";

extend("email_regex", {
  validate: (value) => /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value),
  message: "Please enter a valid email address in the format example@domain.com",
});
export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BFormText,
    BButton,
    BFormDatalist,
    BDropdown,
    BDropdownItem,
    BFormTextarea,
    ValidationProvider,
    ValidationObserver,
    BFormSelect,
    vSelect,
    flatPickr,
    BModal,
    VBModal,
    BTable,
    CustomFieldsDetails,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      modalId: "",
      modalTitle: "",
      modalType: "",
      newItem: "",
      isEdit: false,
      Edit: false,
      currentOptions: [],
      fields: [{ key: "name", sortable: true }, { key: "actions" }],
      optionsSalesPerson: [],
      sourceOptions: [],
      productInterestOptions: [],
      hobbiesOptions: [],
      cityOptions: [],
      jobTitleOptions: [],
      selectedHobbyIds: [],
      selectedProductsInterestedInIds: [],
      id: this.$route.params.id,
      options: [
        { value: null, text: "Please select a title" },
        { value: "Mr", text: "Mr" },
        { value: "Mrs", text: "Mrs" },
        { value: "Ms", text: "Ms" },
      ],
      socialMedias: [
        { text: "Other", value: 0 },
        { text: "Facebook", value: 1 },
        { text: "Instagram", value: 2 },
        { text: "Twitter", value: 3 },
        { text: "LinkedIn", value: 4 },
      ],
      selected: "Select Social Media",
      ProductInterestSelected: [],
      selectedHobbies: [],
      selectedSegments: [],
      ///////////////
      required,
      email,
      // custInfo: null,
      individualCheck: false,
      custInfo: null,
      defaultProfile: {
        source: {
          leadClientDetailId: null,
        },
        city: {
          leadClientDetailId: null,
        },
        jobTitle: {
          leadClientDetailId: null,
        },
        hobbies: [],
        productsInterestedIn: [],
        marketingSegments: [],
      },
      config: {
        wrap: true,
        maxDate: "today",
      },
    };
  },

  computed: {
    ...mapGetters("customerModule", {
      custInfo: "custId",
      details: "details",
      profiledetails: "profiledetails",
      loading: "loading",
    }),
    ...mapGetters("salesPersonModule", {
      SalesPersonList: "salesperson",
      loading: "loading",
    }),
    ...mapGetters("segmentModule", {
      segments: "segments",
      loading: "loading",
    }),
    segmentOptions() {
      // Assuming this.segments is the array containing segment data
      return this.segments.map((segment) => {
        return {
          value: segment.segmentId,
          itemTitle: segment.name,
        };
      });
    },
    modalOptions() {
      if (this.modalType === "PRODUCTINTEREST") {
        return this.productInterestOptions;
      } else if (this.modalType === "SOURCE") {
        return this.sourceOptions;
      } else if (this.modalType === "CITY") {
        return this.cityOptions;
      } else if (this.modalType === "JOBTITLE") {
        return this.jobTitleOptions;
      } else if (this.modalType === "HOBBIE") {
        return this.hobbiesOptions;
      }
      return [];
    },
  },
  async mounted() {
    this.isEdit = HasPermission(PermissionList.Sales_Update);
    await this.getSalesPersonListAction().then(() => {
      this.SalesPersonList.map((v, i) =>
        this.optionsSalesPerson.push({
          value: v.id,
          text: `${v.firstName}` + " " + `${v.lastName}`,
        })
      );
    });
    await this.getSegmentsAction()
      .then((response) => {})
      .catch((response) => {
        console.log(response);
      });
    await this.loadAndRefreshDetails();
    // await this.getCustomersByIDAction(this.id).then((res) => {
    //   this.custInfo = this.$store.getters["customerModule/custId"];
    //   this.individualCheck = this.custInfo.typeDesc == "INDIVIDUAL";
    //   this.selected = this.custInfo.sourceDesc;
    // });
    await this.getCustomerProfileDetailAction(this.id)
      .then((res) => {
        if (this.profiledetails != null) {
          if (this.profiledetails.source == null)
            this.profiledetails.source = this.defaultProfile.source;
          if (this.profiledetails.city == null)
            this.profiledetails.city = this.defaultProfile.city;
          if (this.profiledetails.jobTitle == null)
            this.profiledetails.jobTitle = this.defaultProfile.jobTitle;
          if (this.profiledetails.hobbies == null)
            this.profiledetails.hobbies = this.defaultProfile.hobbies;
          if (this.profiledetails.productsInterestedIn == null)
            this.profiledetails.productsInterestedIn = this.defaultProfile.productsInterestedIn;
          if (this.profiledetails.marketingSegments == null)
            this.profiledetails.marketingSegments = this.defaultProfile.marketingSegments;
        }
      })
      .catch((error) => {
        console.error("Error fetching customer profile details:", error);
      });
  },
  async beforeMount() {
    await this.checkIndividual();
    await this.loadAndRefreshDetails();
  },
  methods: {
    ...mapActions("customerModule", [
      "getCustomersByIDAction",
      "updateCustomersAction",
      "getCustomerProfileDetailAction",
      "getProfileDetailsListAction",
      "addProfileDetailAction",
      "deleteCustomerProfileDetailAction",
    ]),
    ...mapActions("salesPersonModule", ["getSalesPersonListAction"]),

    ...mapActions("segmentModule", [
      "getSegmentsAction",
      "removeSegmentAction",
      "addSegmentAction",
      "updateSegmentAction",
    ]),

    async checkIndividual() {
      try {
        await this.getCustomersByIDAction(this.id);
        this.custInfo = this.$store.getters["customerModule/custId"];
        this.individualCheck = this.custInfo.typeDesc === "INDIVIDUAL";
        this.selected = this.custInfo.sourceDesc;
        return this.individualCheck;
      } catch (error) {
        console.error("Error checking individual:", error);
        this.individualCheck = false;
      }
    },
    saveSocialMedia(value, text) {
      this.custInfo.source = value;
      this.selected = text;
    },
    showErrorAlert(errorMessage) {
      this.$swal({
        title: "Error!",
        text: errorMessage || "An error occurred while adding the profile detail",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },

    showSuccessAlert(msg) {
      this.$swal({
        title: "Success!",
        text: msg,
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    addLeadsIndividual() {
      this.$refs.formIndividual.validate().then((success) => {
        if (success) {
          this.$swal({
            title: "Updating Customer",
            text: "Please wait while the customer is being updated...",
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
              this.$swal.showLoading();
              let payload = {
                id: this.custInfo.id,
                otherName: this.custInfo.otherName,
                surname: this.custInfo.surname,
                salesPersonId: this.custInfo.salesPersonId,
                email: this.custInfo.email,
                addressLine1: this.custInfo.addressLine1,
                addressLine2: this.custInfo.addressLine2,
                dob: this.custInfo.dob != "" ? this.custInfo.dob : null,
                tel: this.custInfo.tel,
                fieldInstruction: this.custInfo.fieldInstruction,
                title: this.custInfo.title,
                jobTitle: this.custInfo.jobTitle,
                comments: this.custInfo.comments,
                profile: {
                  source: this.profiledetails.source.leadClientDetailId,
                  city: this.profiledetails.city.leadClientDetailId,
                  jobTitle: this.profiledetails.jobTitle.leadClientDetailId,
                  hobbies: this.selectedHobbies.map((hobby) => hobby.value),
                  productsInterestedIn:
                    this.ProductInterestSelected != []
                      ? this.ProductInterestSelected.map((product) => product.value)
                      : [],
                  marketingSegments: this.selectedSegments.map(
                    (segment) => segment.value
                  ),
                },
                additionalFields: this.custInfo.additionalFields,
              };
              console.log("ind. payload", payload);
              this.updateCustomersAction(payload)
                .then(() => {
                  this.$swal.hideLoading();
                  this.success();
                })
                .catch(() => {
                  this.$swal.hideLoading();
                  this.error();
                });
            },
          });
        }
      });
    },

    addLeadsCompany() {
      let payload = {
        id: this.custInfo.id,
        otherName: this.custInfo.otherName,
        surname: this.custInfo.surname,
        email: this.custInfo.email,
        companyName: this.custInfo.companyName,
        addressLine1: this.custInfo.addressLine1,
        addressLine2: this.custInfo.addressLine2,
        tel: this.custInfo.tel,
        fieldInstruction: this.custInfo.fieldInstruction,
        website: this.custInfo.website,
        vatNumber: this.custInfo.vatNumber,
        comments: this.custInfo.comments,
        brn: this.custInfo.brn,
        type: 1,
        status: 0,
        isActive: true,
        salesPersonId: this.custInfo.salesPersonId,
        profile: {
          source: this.profiledetails.source.leadClientDetailId,
          city: this.profiledetails.city.leadClientDetailId,
          productsInterestedIn: this.ProductInterestSelected.map(
            (product) => product.value
          ),
          marketingSegments: this.selectedSegments.map((segment) => segment.value),
        },
        additionalFields: this.custInfo.additionalFields,
      };
      console.log("xyz", payload);

      this.$swal({
        title: "Updating Customer",
        text: "Please wait while the Customer is being updated...",
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
          this.updateCustomersAction(payload)
            .then(() => {
              this.$swal.hideLoading();
              this.success();
            })
            .catch(() => {
              this.$swal.hideLoading();
              this.error();
            });
        },
      });
    },
    async loadAndRefreshDetails() {
      this.$swal({
        title: "Loading...",
        text: "Please wait while the details are loading...",
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      
      
      if (!this.custInfo) {
        await this.getCustomersByIDAction(this.id);
        this.custInfo = this.$store.getters["customerModule/custId"];
      }
      
      const typeArrays = {
        SOURCE: this.sourceOptions,
        PRODUCTINTEREST: this.productInterestOptions,
        HOBBIE: this.hobbiesOptions,
        CITY: this.cityOptions,
        JOBTITLE: this.jobTitleOptions,
      };
      await this.getProfileDetailsListAction().then((response) => {
        for (const [type, optionsArray] of Object.entries(typeArrays)) {
          const filteredData = this.details
            .filter((item) => item.type === type)
            .sort((a, b) => a.name.localeCompare(b.name));
          optionsArray.splice(
            0,
            optionsArray.length,
            ...filteredData.map((item) => ({
              value: item.id,
              text: item.name,
              itemTitle:
                type === "PRODUCTINTEREST" || type === "HOBBIE"
                  ? item.name
                  : undefined,
            }))
          );
          console.log(`Updated ${type} Options:`, optionsArray); // Debugging line
        }
      });

      try {
        await this.getCustomerProfileDetailAction(this.id);

        if (this.profiledetails != null) {
          if (this.profiledetails.source == null)
            this.profiledetails.source = this.defaultProfile.source;
          if (this.profiledetails.city == null)
            this.profiledetails.city = this.defaultProfile.city;
          if (this.profiledetails.jobTitle == null)
            this.profiledetails.jobTitle = this.defaultProfile.jobTitle;
          if (this.profiledetails.hobbies == null)
            this.profiledetails.hobbies = this.defaultProfile.hobbies;
          if (this.profiledetails.productsInterestedIn == null)
            this.profiledetails.productsInterestedIn = this.defaultProfile.productsInterestedIn;
          if (this.profiledetails.marketingSegments == null)
            this.profiledetails.marketingSegments = this.defaultProfile.marketingSegments;
        }

        this.ProductInterestSelected =
          this.profiledetails.productsInterestedIn == null
            ? []
            : this.profiledetails.productsInterestedIn.map((product) => ({
                value: product.leadClientDetailId,
                itemTitle: product.name,
                text: product.name,
              }));

        this.selectedHobbies =
          this.profiledetails.hobbies == null
            ? []
            : this.profiledetails.hobbies.map((hobby) => ({
                value: hobby.leadClientDetailId,
                itemTitle: hobby.name,
                text: hobby.name,
              }));
        this.selectedSegments =
          this.profiledetails.marketingSegments == null
            ? []
            : this.profiledetails.marketingSegments.map((segment) => ({
                value: segment.externalReference,
                itemTitle: this.segments.find(
                  (s) => s.segmentId === segment.externalReference
                )?.name,
              }));

       
        if (this.custInfo?.sourceDesc && this.profiledetails?.source) {
          const target = String(this.custInfo.sourceDesc).trim().toLowerCase();
          const matchedSource = this.sourceOptions.find((opt) => {
            const label = String(opt.text || opt.itemTitle || "").trim().toLowerCase();
            return label === target;
          });
          if (matchedSource) {
            this.$set(
              this.profiledetails.source,
              "leadClientDetailId",
              matchedSource.value
            );
          }
        }
      
      
        if (this.custInfo?.city && this.profiledetails?.city) {
          const target = String(this.custInfo.city).trim().toLowerCase();
          
          const matchedCity = this.cityOptions.find((opt) => {
            const label = String(opt.text || opt.itemTitle || "").trim().toLowerCase();
            return label === target;
          });
          if (matchedCity) {
            
            this.$set(
              this.profiledetails.city,
              "leadClientDetailId",
              matchedCity.value
            );
          } else {
            //console.log("No found matcH:", target);
          }
        } else {
          
        }

       
        if (this.custInfo?.jobTitle && this.profiledetails?.jobTitle) {
          const target = String(this.custInfo.jobTitle).trim().toLowerCase();
          const matchedJob = this.jobTitleOptions.find((opt) => {
            const label = String(opt.text || opt.itemTitle || "").trim().toLowerCase();
            return label === target;
          });
          if (matchedJob) {
            this.$set(
              this.profiledetails.jobTitle,
              "leadClientDetailId",
              matchedJob.value
            );
          }
        }
      } catch (error) {
        throw new Error(error.message)
      }

      this.$swal.close();
    },
    getModalTitle(type) {
      switch (type.toLowerCase()) {
        case "hobbie":
          return "Hobbies";
        case "productinterest":
          return "Product Interest";
        case "city":
          return "City";
        case "jobtitle":
          return "Job Title";
        case "source":
          return "Source";
        default:
          return "Unknown Type";
      }
    },
    showModal(type) {
      this.modalType = type;
      this.modalId = `modal-${type.toLowerCase()}`;
      this.modalTitle = `Add ` + this.getModalTitle(type);

      this.currentOptions = this[`${type.toLowerCase()}Options`];
      this.$nextTick(() => {
        this.$bvModal.show(this.modalId);
      });
    },
    addItem() {
      this.$swal({
        title: "Loading...",
        text: "Please wait while the item is being added...",
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });

      // Validate character limits for "JOBTITLE" and "SOURCE" types
      if (
        (this.modalType === "JOBTITLE" && this.newItem.length > 100) ||
        (this.modalType === "SOURCE" && this.newItem.length > 50)
      ) {
        // Show SweetAlert if character limit is exceeded
        this.$swal({
          title: "Error!",
          text:
            this.modalType === "JOBTITLE"
              ? "Job title should not exceed 100 characters."
              : "Source should not exceed 50 characters.",
          icon: "error",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          buttonsStyling: false,
        });
        return;
      }

      const payload = {
        name: this.newItem,
        type: this.modalType,
      };

      this.addProfileDetailAction(payload)
        .then(() => {
          this.loadAndRefreshDetails();
          this.showSuccessAlert("Item added successfully!");
          this.newItem = "";
          this.$bvModal.hide(this.modalId);
        })
        .catch((error) => {
          // console.log(error);
          console.log("This is an error: ", error);
          // Extract error message from the API response
          let errorMsg = "Failed to add item.";
          if (error.response?.data?.message) {
            errorMsg = error.response.data.message; // This ensures we show the correct backend error
          }

          // Display the error message using SweetAlert
          this.$swal({
            title: "Error!",
            text: errorMsg,
            icon: "error",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            buttonsStyling: false,
          });
        });
      this.newItem = "";
      this.$bvModal.hide(this.modalId);
    },

    deleteItem(value) {
      this.$swal({
        title: "Loading...",
        text: "Please wait while the item is being deleted...",
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      this.deleteCustomerProfileDetailAction(value)
        .then(() => {
          this.loadAndRefreshDetails();
          this.showSuccessAlert("Item deleted successfully!");
        })
        .catch((error) => {
          this.showErrorAlert("Failed to delete item: " + error.message);
          this.$swal.close();
        });
    },
    success() {
      this.$swal({
        title: "Customer!",
        text: "You have successfully updated the Customer!",
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      }).then((result) => {
        this.$router.push({ name: "customer-view" });
      });
    },

    // error
    error() {
      this.$swal({
        title: "Error!",
        text: " Failed!",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },

    resetForm() {
      this.$swal({
        title: "Resetting Form",
        text: "Please wait while the form is being reset...",
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
          this.getCustomersByIDAction(this.id)
            .then((res) => {
              this.$swal.hideLoading();
              if (this.custInfo.typeDesc == "INDIVIDUAL") {
                this.individualCheck = true;
              } else {
                this.individualCheck = false;
              }
              this.$swal({
                title: "Success",
                text: "The form has been reset.",
                icon: "success",
              });
            })
            .catch((error) => {
              this.$swal.hideLoading();
              this.$swal({
                title: "Error",
                text: `Error resetting form: ${error.message}`,
                icon: "error",
              });
            });
        },
      });
    },

    submitForm() {
      // emit the data to another page
      this.custInfo.companyName =
        this.custInfo.type == 1 ? this.custInfo.otherName : null;
      this.$emit("onchange", this.individual);
    },
    validateDob(newDate) {
      const year = new Date(newDate).getFullYear();
      if (year < 1900 || year > 2100) {
        const nearestYear = Math.min(Math.max(year, 1900), 2100);
        this.custInfo.dob = new Date(newDate);
        this.custInfo.dob.setFullYear(nearestYear);
        this.$swal.fire({
          title: "Invalid Year",
          text: `Please select a year between 1900 and 2100.`,
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
    },
    additionalFieldChanges(customFields) {
      this.custInfo.additionalFields = customFields;
      console.log(
        "🚀 ~ additionalFieldChanges ~ this.custInfo.additionalFields:",
        this.custInfo.additionalFields
      );
      console.log("🚀 ~ additionalFieldChanges ~ customFields:", customFields);
    },
  },
  watch: {
    "custInfo.dob"(newDate) {
      this.validateDob(newDate);
    },
  },
  setup(props) {
    return {
      PermissionList,
      HasPermission,
    };
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
